import React from "react"

const Aeroplane = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    width="22.414"
    height="22.414"
    viewBox="0 0 22.414 22.414"
  >
    <g id="send" transform="translate(-1 -0.586)">
      <line
        id="Line_15"
        data-name="Line 15"
        x1="11"
        y2="11"
        transform="translate(11 2)"
        fill="none"
        stroke="#e5dcd3"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
      <path
        id="Path_7212"
        data-name="Path 7212"
        d="M22,2,15,22l-4-9L2,9Z"
        fill="none"
        stroke="#e5dcd3"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </g>
  </svg>
)

export default Aeroplane
